module.exports = __webpack_public_path__ + "static/lizardfolk_librarians_mtg_ahbg-f13812857fa16de3fd3a62ee4a89869b.jpg";